import type { ActionIconsProps } from '@/components/Markets/ActionIcons/ActionIcons.types'

export const actionIconsDefaultProps: ActionIconsProps = {
  noSpaceBetween: false,
  position: 'center',
  loading: 'lazy',
  googleLink: 'https://play.google.com/store/apps/details?id=com.hmarkets.mobile&pli=1',
  appleLink: 'https://apps.apple.com/ae/app/hantec-markets-online-trading/id1666779240'
}
